import { DistributionService } from './distribution.service';

export const services: any[] = [
	DistributionService,
];

export * from './distribution.service';
